export default function identity(val) {
  return val;
};